/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassroomdisciplineIdChannels202,
  PostApiV1ClassroomdisciplineIdChannels400,
  PostApiV1ClassroomdisciplineIdChannels401,
  PostApiV1ClassroomdisciplineIdChannels404,
  PostApiV1ClassroomdisciplineIdChannelsMutationRequest,
  PostApiV1ClassroomdisciplineIdChannelsMutationResponse,
  PostApiV1ClassroomdisciplineIdChannelsPathParams,
} from "../../types/classPlanningChannelsController/PostApiV1ClassroomdisciplineIdChannels.ts";
import { upsertChannelRequestViewModelSchema } from "../upsertChannelRequestViewModelSchema.ts";

export const postApiV1ClassroomdisciplineIdChannelsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannelsPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ClassroomdisciplineIdChannels202Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannels202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ClassroomdisciplineIdChannels400Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannels400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassroomdisciplineIdChannels401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannels401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ClassroomdisciplineIdChannels404Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannels404>;

export const postApiV1ClassroomdisciplineIdChannelsMutationRequestSchema =
  z.lazy(
    () => upsertChannelRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannelsMutationRequest>;

export const postApiV1ClassroomdisciplineIdChannelsMutationResponseSchema =
  z.lazy(
    () => postApiV1ClassroomdisciplineIdChannels202Schema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdChannelsMutationResponse>;
